import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux'

import { SalesforceBaseUrlSelector, IntegrationSelector } from '../../selectors';

class DealSourceLink extends Component {

  render(){

    const {
      integration,
      salesforceBaseUrl,
      deal
    } = this.props;

    if(!integration || !salesforceBaseUrl || !deal.source){
      return null;
    }

    const DEFAUL_LABEL = 'View in Salesforce';

    return (
      <a href={`${salesforceBaseUrl}/${deal._id}`} target="_blank" className="link-to-source">{this.props.label || DEFAUL_LABEL}</a>
    )
  }
}

const mapStateToProps = state => {
  return {
    integration: IntegrationSelector(state),
    salesforceBaseUrl: SalesforceBaseUrlSelector(state)
  }
}

export default connect(mapStateToProps)(DealSourceLink);



// WEBPACK FOOTER //
// ./src/components/shared/dealSourceLink.js